import React from "react";
import {Card, CardBody, CardHeader, CardTitle, Button, Row, Col} from "reactstrap";
import {BackgroundColorContext} from "../../contexts/BackgroundColorContext";
import {useNavigate} from "react-router-dom";

interface AuthenticationRequiredProps {
  title?: string;
  message?: string;
  featureName?: string;
}

const AuthenticationRequired: React.FC<AuthenticationRequiredProps> = ({
  title = "Authentication Required",
  message,
  featureName
}) => {
  const navigate = useNavigate();

  const getDefaultMessage = () => {
    if (featureName) {
      return `You must be signed in to access ${featureName}.`;
    }
    return "You must be signed in to access this feature.";
  };

  const handleSignIn = () => {
    navigate("/auth/signin");
  };

  return (
    <BackgroundColorContext.Consumer>
      {({color}) => (
        <Row>
          <Col md="12">
            <Card>
              <CardHeader data-color={color} className="no-body">
                <CardTitle>{title}</CardTitle>
              </CardHeader>
              <CardBody className="text-center">
                <div className="auth-required-content">
                  <i className="fa fa-lock fa-3x mb-3 text-muted"></i>

                  <p className="lead mb-4">{message || getDefaultMessage()}</p>

                  <div className="auth-explanation mb-4">
                    <h5 className="mb-3">TrainerDX Features:</h5>
                    <Row>
                      <Col md="6">
                        <div className="feature-info mb-3">
                          <h6 className="text-success">
                            <i className="fa fa-check mr-2"></i>
                            Free Access
                          </h6>
                          <ul className="text-left">
                            <li>Demo reports</li>
                            <li>Benchmarks</li>
                            <li>Public search</li>
                            <li>Ping test</li>
                            <li>Help system</li>
                          </ul>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="feature-info mb-3">
                          <h6 className="text-primary">
                            <i className="fa fa-user mr-2"></i>
                            Requires Sign In
                          </h6>
                          <ul className="text-left">
                            <li>Upload & analyze logs (5 free monthly)</li>
                            <li>Your personal log history</li>
                            <li>Report sharing</li>
                            <li>Settings & preferences</li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="auth-actions">
                    <Button color="primary" data-color={color} size="lg" onClick={handleSignIn}>
                      <i className="fa fa-sign-in-alt mr-2"></i>
                      Sign In
                    </Button>
                  </div>

                  <p className="mt-3 text-muted small">
                    <i className="fa fa-shield-alt mr-1"></i>
                    No ads, no data selling, no subscriptions
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </BackgroundColorContext.Consumer>
  );
};

export default AuthenticationRequired;
